import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { t } from "ttag"

import { ApplicationFeature } from "../ApplicationNavigation"

export const useSetupDocumentTitle = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const title = deduceTitleFromPathname(pathname)

    if (title) {
      document.title = title
    }
  }, [ pathname ])

  function deduceTitleFromPathname(pathname: string): string | undefined {
    const feature = pathname.split("/")[1]

    switch (feature) {
      case ApplicationFeature.SpeakUp: return t`SpeakUP - Administration`
      case ApplicationFeature.Lea: return t`léa - Administration`
      case ApplicationFeature.Led: return t`LED - Administration`
      case ApplicationFeature.Pimeo: return t`Piméo - Administration`
      case ApplicationFeature.Users: return t`Users - Administration`
      case ApplicationFeature.Settings: return t`Settings - Administration`
    }
  }
}
